export const SET_ACTIVE_COMPANY = 'SET_ACTIVE_COMPANY';
export const CLEAR_ACTIVE_COMPANY = 'CLEAR_ACTIVE_COMPANY';

const initialState = null;

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACTIVE_COMPANY:
            return action.payload;
        case CLEAR_ACTIVE_COMPANY:
            return null;
        default:
            return state;
    }
};

const storeName = 'activeCompany';
const storeMapping = { [storeName]: reducer };

export const activeCompanySelector = (state) => state[storeName];

export default storeMapping;
